export function flatten(array) {
  return [].concat.apply([], array)
}

export function filterUnique(array) {
  return array.filter((item, index) => array.indexOf(item) === index)
}
